<template>
  <div class="md:col-span-1 flex justify-between">
    <div class="flex items-start gap-1 flex-col">
      <h3 class="text-lg leading-0 font-medium text-vice-teal-700">
        <slot name="title"></slot>
      </h3>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
